import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';  
import BountyItem from '../../components/BugBounty/BountyItem';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const CompanyDashboard = () => {
    const params = useParams()

    const [bounties,setBounties] = useState([])

const getBounties = async () => {
    const data = new FormData()
    data.append('organization_id',1)
    // data.append('organization_id',params.id)


    try {
        const responds = await axios.post(ENDPOINT+'company-based-bounties.php',data,SecurityHeaders)
        if(responds && responds.data.status === 'success'){
            setBounties(responds.data.data)
            
        }

  
    } catch (error) {
        console.error(error)
    }

}



useEffect(() => {
    getBounties()
}, [])   
console.log(bounties)
  return (
    <>

<div className='container py-5' >
<Link to='/add-bug-bounty' className='btn btn-primary' >
        Add Bounty
      </Link>
 <div className="row gy-2 mb-2 container mx-auto">

{
bounties? bounties.map((item)=>(
<BountyItem key={item.bounty_id} item={item} reload={getBounties} />

)):null
}
 </div>
</div>

      
    </>
  )
}

export default CompanyDashboard

export const CompanyStyles = styled.button` 

`
    